import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/Global-Services/common.service';
import { ExcelUploadService } from 'src/app/Global-Services/excel-upload.service';

@Component({
  selector: 'app-employee-export',
  templateUrl: './employee-export.component.html',
  styleUrls: ['./employee-export.component.css'],
   standalone: false,
})
export class EmployeeExportComponent implements OnInit {


  ErrorMessage = [];
  FTERecordsList = {
    FromDate: '',
    ToDate: ''
  }
  boolReturn: any;

  constructor(private router: Router, public gService: CommonService, public ExcelUpload: ExcelUploadService) { }

  ngOnInit() {
  }

  ChangeDateFormat($event: any, arg1: string) {
  }
  ResetResult() {
    this.FTERecordsList = {
      FromDate: '',
      ToDate: ''
    }
  }
  ExportToExcel() {

    this.gService.ExportExcelDataForEmployees(this.FTERecordsList).subscribe((data: any) => {
      if (data != null) {
        if (data.length > 0) {
          this.ExcelUpload.exportAsExcelFile(data, 'FTE_List');
        }
      }
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(() => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }
  onExit() {
    this.boolReturn = false;
    this.boolReturn = confirm('Are you sure you want to Exit?');
    if (this.boolReturn === false) {
      return;
    }
    this.router.navigate(['/INFTE/home']);
  }

}
